import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Dialog from '../../../../components/ModalDialog'
import CreateIcon from '../../../../assets/icons/settingsCorner/iconsCreate'
import { StyledDivContent, StyledInputTitle, sxInput } from '../../styled'
import AutoComplete from '../../../../components/AutoComplete'
import { getName } from '../../../../utils/values'

function DriverKeyModal({
  open,
  handleClose,
  modalTitle,
  drivers,
  keys,
  fetchKeys,
  searchKeys,
  fetchDrivers,
  fetchMoreDrivers,
  searchDrivers,
  assign,
  isLoadingAssign,
  success,
  errorMessage,
  fetchMoreKeys,
  keysCount,
  resetDriver,
  resetConfig,
  isLoadingDrivers,
  isLoadingKeysList,
}) {
  const [init, setInit] = useState(false)
  const [key, setKey] = useState('')
  const [offsetKey, setOffsetKey] = useState(25)
  const [searchKey, setSearchKey] = useState('')
  const [selectkey, setSelectKey] = useState(false)

  const [driver, setDriver] = useState('')
  const [offsetDriver, setOffsetDriver] = useState(25)
  const [searchDriver, setSearchDriver] = useState('')
  const [selectDriver, setSelectDriver] = useState(false)

  const UserId = String(JSON.parse(localStorage.getItem('currentUser'))?.id)
  const date = new Date().toISOString()

  useEffect(() => {
    fetchDrivers()
    fetchKeys()
    setInit(true)
  }, [])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchDriver.length > 0 && !selectDriver) {
        searchDrivers(searchDriver)
        setOffsetDriver(25)
      } else {
        if (init) {
          searchDrivers('')
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchDriver])

  const onChangeSearchDriver = (value) => {
    setSelectDriver(false)

    if (value) {
      let val = value.trim()
      setSearchDriver(val)
    } else {
      setDriver('')
      setSearchDriver('')
    }
  }

  const onSelectDrive = (value) => {
    if (value) {
      setDriver(value)
      setSearchDriver('')
      setSelectDriver(true)
    }
  }
  const loadMoreDrivers = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      keysCount >= offsetDriver
    ) {
      fetchMoreDrivers(offsetDriver + 25)
      setOffsetDriver(offsetDriver)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchKey.length > 0 && !selectkey) {
        searchKeys(searchKey)
        setOffsetKey(25)
      } else {
        if (init) {
          searchKeys('')
        }
      }
    }, 500)

    return () => clearTimeout(delayDebounceFn)
  }, [searchKey])

  const onChangeSearchKey = (value) => {
    setSelectKey(false)

    if (value) {
      let val = value.trim()
      setSearchKey(val)
    } else {
      setKey('')
      setSearchKey('')
    }
  }

  const onSelectKey = (value) => {
    if (value) {
      setKey(value)
      setSearchKey('')
      setSelectKey(true)
    }
  }
  const loadMoreKeys = (event) => {
    if (
      Math.round(event.target.scrollHeight - event.target.scrollTop) ==
        event.target.clientHeight &&
      keysCount >= offsetKey
    ) {
      fetchMoreKeys(offsetKey + 25)
      setOffsetKey(offsetKey)
    }
  }

  const onAssign = () => {
    const data = {
      affectDate: date,
      keyId: key.id,
      userId: UserId,
      driverId: driver.id,
    }
    assign(data)
  }

  useEffect(() => {
    if (success) {
      handleClose()
    }
  }, [success])

  useEffect(() => {
    window.addEventListener('beforeunload', resetDriver)
    window.addEventListener('beforeunload', resetConfig)

    return () => {
      resetDriver()
      resetConfig()
      window.removeEventListener('beforeunload', resetDriver)
      window.removeEventListener('beforeunload', resetConfig)
    }
  }, [])

  return (
    <Dialog
      maxWidthDialog={'md'}
      open={open}
      title={modalTitle}
      iconTitle={<CreateIcon />}
      style={errorMessage ? { display: 'none' } : {}}
      content={
        <StyledDivContent>
          <StyledInputTitle>Chauffeur</StyledInputTitle>

          <AutoComplete
            value={driver}
            onChange={(event, value) => {
              onSelectDrive(value)
            }}
            onInputChange={(event, value) => onChangeSearchDriver(value)}
            id="Driver-list"
            options={drivers}
            getOptionLabel={(option) => getName(option?.firstName, option?.lastName)}
            variant="outlined"
            placeholder={'Choisir une clé'}
            sxInputStyle={sxInput}
            ListboxProps={{
              onScroll: loadMoreDrivers,
            }}
            renderOption={(props, option) => (
              <li id={`cle-${option.id}`} {...props}>
                <div className="AutoCompteFilterOption">
                  {getName(option?.firstName, option?.lastName)}
                </div>
              </li>
            )}
            loading={isLoadingDrivers}
          />
          <div style={{ marginTop: '20px', width: '100%' }}>
            <StyledInputTitle>Clé </StyledInputTitle>{' '}
            <AutoComplete
              value={key}
              onChange={(event, value) => {
                onSelectKey(value)
              }}
              onInputChange={(event, value) => onChangeSearchKey(value)}
              id="Cle-Driver-list"
              options={keys}
              getOptionLabel={(option) => option.value}
              variant="outlined"
              placeholder={'Choisir une clé'}
              sxInputStyle={sxInput}
              ListboxProps={{
                onScroll: loadMoreKeys,
              }}
              renderOption={(props, option) => (
                <li id={`cle-${option.id}`} {...props}>
                  <div className="AutoCompteFilterOption">{`${option.value} -- ${option.label}`}</div>
                </li>
              )}
              loading={isLoadingKeysList}
            />
          </div>
        </StyledDivContent>
      }
      handleClose={handleClose}
      handleClickAction={onAssign}
      disabled={!key || !driver}
      isLoadingButtonAction={isLoadingAssign}
    />
  )
}
DriverKeyModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  keys: PropTypes.array,
  modalTitle: PropTypes.string,
  drivers: PropTypes.array,
  fetchKeys: PropTypes.func,
  fetchDrivers: PropTypes.func,
  searchKeys: PropTypes.func,
  assign: PropTypes.func,
  isLoadingAssign: PropTypes.bool,
  errorMessage: PropTypes.bool,
  success: PropTypes.bool,
  fetchMoreKeys: PropTypes.func,
  keysCount: PropTypes.number,
  resetDriver: PropTypes.func,
  resetConfig: PropTypes.func,
  fetchMoreDrivers: PropTypes.func,
  searchDrivers: PropTypes.func,
  isLoadingDrivers: PropTypes.bool,
  isLoadingKeysList: PropTypes.bool,
}

export default DriverKeyModal
